import { RefObject, useEffect, useState } from 'react';
import { CommentEntry, OverlayEntry } from './contentDiffComparisonTypes';
import { computeOverlayPositions, overlayPositionsEqual } from './contentDiffComparisonUtils';

export function useCommentOverlayPositions(
  comments: CommentEntry[],
  diffHtml: string,
  diffContainerRef: RefObject<HTMLDivElement | null>,
) {
  const [overlayPositions, setOverlayPositions] = useState<OverlayEntry[]>([]);

  useEffect(() => {
    if (!comments.length || !diffHtml.trim()) {
      setOverlayPositions((prev) => (prev.length ? [] : prev));
      return;
    }

    const recalculatePositions = () => {
      const container = diffContainerRef.current;
      if (!container) {
        setOverlayPositions((prev) => (prev.length ? [] : prev));
        return;
      }

      const nextPositions = computeOverlayPositions(container, comments);

      setOverlayPositions((prev) =>
        overlayPositionsEqual(prev, nextPositions) ? prev : nextPositions,
      );
    };

    recalculatePositions();

    window.addEventListener('resize', recalculatePositions);
    return () => window.removeEventListener('resize', recalculatePositions);
  }, [comments, diffHtml, diffContainerRef]);

  return overlayPositions;
}
